import React, { useState } from 'react';
import { schoolLogoSrc } from '../utils/schoolLogo';

const BASE = `${process.env.PUBLIC_URL || ''}/site/images`;

/** Official school portal URL (this deployment). */
const SITE_URL = 'https://mpsvns.web.app';
const SITE_DISPLAY = 'mpsvns.web.app';

function siteImg(name) {
  return `${BASE}/${name}`;
}

const NAV = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About Us' },
  { id: 'admissions', label: 'Admissions' },
  { id: 'training', label: 'Training Courses' },
  { id: 'success', label: 'Success Stories' },
  { id: 'gallery', label: 'School Gallery' },
  { id: 'contact', label: 'Contact' },
];

const GALLERY_IMAGES = [
  'school_front.jpg',
  'front1.jpg',
  'front2.jpg',
  ...Array.from({ length: 10 }, (_, i) => `${String(i + 1).padStart(4, '0')}.jpg`),
  ...Array.from({ length: 12 }, (_, i) => `SCH${String(i + 1).padStart(4, '0')}.jpg`),
];

const TRAINING_DRIVE_LINKS = [
  { label: 'L.K.G.', href: 'https://drive.google.com/file/d/1HeEpXoDfl0UD-DkboeYmIeyA4sx7J73A/view?usp=sharing' },
  { label: 'U.K.G', href: 'https://drive.google.com/file/d/1eBKa-0c5bFVf4ddhM9ozabDuqmyNRl_R/view?usp=sharing' },
  { label: 'Class I', href: 'https://drive.google.com/file/d/1i6kXzBRxqg1zTcdmVcOOdKswFge3UTg2/view?usp=sharing' },
  { label: 'Class II', href: 'https://drive.google.com/file/d/1u0q-tIxVohvyNDKofJ-OGPmMOhUCsU4_/view?usp=sharing' },
  { label: 'Class III', href: 'https://drive.google.com/file/d/1MjQac7n-13MEEEylJXwApH6HoHHoiws_/view?usp=sharing' },
  { label: 'Class IV', href: 'https://drive.google.com/file/d/102edCMx2HoPJL6bhUwMFdj9272Wvk99T/view?usp=sharing' },
  { label: 'Class V', href: 'https://drive.google.com/file/d/1nIElDof63IFfqSb8Gt_8gzjgIHkx_ua1/view?usp=sharing' },
  { label: 'Class VI', href: 'https://drive.google.com/file/d/1jY-ai0Mds4lHhjRH3x_vtMAf0EkoxoFP/view?usp=sharing' },
  { label: 'Class VII', href: 'https://drive.google.com/file/d/1icr3UVGLnoJlzG_J-XKmabMV4BUuoQAl/view?usp=sharing' },
  { label: 'Class VIII (without Hindi)', href: 'https://drive.google.com/file/d/1d7QcMJJaUNtyg5krnA5ZCRjFl6MZkMig/view?usp=sharing' },
  { label: 'Class VIII Hindi', href: 'https://drive.google.com/file/d/16tkVw3UZMHJdmMrkjnYETL1TqJT5aiLd/view?usp=sharing' },
];

const TRAINING_ACTIVITIES = [
  'Spell well.',
  'Fancy dress.',
  'Plantation of flowers.',
  'Dramatization.',
  'Placard decoration competition.',
  'Chart making competition.',
  'Puppet show competition.',
  'Ramp show.',
  'Bulletin Board Decoration.',
  'Flower making.',
  'Scrap book making.',
  'Science exhibition.',
  'Dance competition',
  'Quiz competition',
  'Republic Day',
];

export default function SchoolPublicSite() {
  const [section, setSection] = useState('home');

  return (
    <div className="mps-school">
      <header className="mps-school-header">
        <div className="mps-school-brand">
          <div className="mps-school-logo-wrap" aria-hidden="true">
            <img src={schoolLogoSrc()} alt="Modern Public School logo" width={80} height={80} />
          </div>
          <div className="mps-school-brand-text">
            <h1 className="mps-school-title-text">Modern Public School</h1>
            <div className="mps-school-contact-line">
              <a href={SITE_URL} className="mps-school-site-link" target="_blank" rel="noopener noreferrer">
                {SITE_DISPLAY}
              </a>
              <span className="mps-school-phone">
                <a href="tel:+919451093677">9451093677</a>
                {' / '}
                <a href="tel:+917839167980">7839167980</a>
              </span>
            </div>
          </div>
        </div>
        <p className="mps-school-tagline">
          <strong>Fear of God is the beginning of knowledge</strong> — Serve Mankind to Serve God.
        </p>
        <nav className="mps-school-nav" aria-label="School pages">
          {NAV.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`mps-school-nav-btn${section === item.id ? ' mps-school-nav-btn-active' : ''}`}
              onClick={() => setSection(item.id)}
            >
              {item.label}
            </button>
          ))}
          <a className="mps-school-nav-btn mps-school-nav-login" href="#erp-login">
            Login
          </a>
        </nav>
      </header>

      <div className="mps-school-body">
        {section === 'home' ? (
          <div className="mps-school-section">
            <h2 className="mps-school-h2 mps-school-display-upper">Welcome to Modern Public School</h2>
            <div className="mps-school-hero">
              <img src={siteImg('school_front.jpg')} alt="MODERN PUBLIC SCHOOL campus" loading="lazy" />
            </div>

            <div className="mps-school-grid-2">
              <article className="mps-school-card">
                <h3>Director&apos;s message</h3>
                <img className="mps-school-portrait" src={siteImg('direc.jpg')} alt="Manoj Kumar Singh" loading="lazy" />
                <h4>Director: Manoj Kumar Singh</h4>
                <p>
                  I feel immense joy at the progress being made by Modern Public School. The seed of an idea sown in the year 1995 by a visionary pioneer Shri
                  Kalindar Prasad Singh has taken firm roots, and the school is growing into a strong tree. It is the endeavor of Modern Public School to make
                  the academic life of our students adventurous and joyful, replete with attainments and achievement. At MPS we create an educational path for the
                  students to tread on.
                </p>
              </article>
              <aside className="mps-school-card mps-school-calendar">
                <h3>School calendar</h3>
                <ul className="mps-school-cal-list">
                  <li>
                    <div className="mps-school-cal-date">
                      <span>26</span>
                      <span>Jan</span>
                    </div>
                    <div>
                      <h4>Republic Day</h4>
                      <p>Republic Day honours the date on which the Constitution of India came into effect on 26 January 1950.</p>
                    </div>
                  </li>
                  <li>
                    <div className="mps-school-cal-date">
                      <span>15</span>
                      <span>Aug</span>
                    </div>
                    <div>
                      <h4>Independence Day</h4>
                      <p>Celebrated on 15 August as a national holiday commemorating the nation&apos;s independence.</p>
                    </div>
                  </li>
                  <li>
                    <div className="mps-school-cal-date">
                      <span>2</span>
                      <span>Oct</span>
                    </div>
                    <div>
                      <h4>Gandhi Jayanti</h4>
                      <p>A national festival marking the birthday of Mohandas Karamchand Gandhi.</p>
                    </div>
                  </li>
                </ul>
              </aside>
            </div>

            <div className="mps-school-grid-3">
              <article className="mps-school-card">
                <img className="mps-school-portrait" src={siteImg('manag.JPG')} alt="Rita Singh" loading="lazy" />
                <h4>Manager: Rita Singh</h4>
                <p>
                  I think only child of today can contribute in the future development. So it is better that we educate today&apos;s child and make them part of
                  the better society. I am pleased to be a part of such an educational institute and thank God for giving such a life to serve the education to
                  your child.
                </p>
              </article>
              <article className="mps-school-card">
                <img className="mps-school-portrait" src={siteImg('princ.jpg')} alt="Uma Singh" loading="lazy" />
                <h4>Principal: Uma Singh</h4>
                <p>
                  I totally believe education is the most powerful weapon and we can get anything with the help of that. We should use it wisely and we should
                  thank God for such a wonderful life. We and the whole Modern family dedicate ourselves to serve the students and educate them for the
                  betterment of the society and for their bright future.
                </p>
              </article>
              <article className="mps-school-card">
                <img className="mps-school-portrait" src={siteImg('vice.jpg')} alt="Santosh Kumar Srivastav" loading="lazy" />
                <h4>Vice-Principal: Santosh Srivastav</h4>
                <p>
                  By discipline and punctuality we can achieve our life goals and it is important to develop these in the children. I am very fortunate to get
                  a chance to educate today&apos;s children.
                </p>
              </article>
            </div>
          </div>
        ) : null}

        {section === 'about' ? (
          <div className="mps-school-section">
            <h2 className="mps-school-h2">About us</h2>
            <div className="mps-school-card">
              <h3>Founder</h3>
              <img className="mps-school-portrait" src={siteImg('baba.jpg')} alt="Kalindar Prasad Singh" loading="lazy" />
              <h4>Banarasi Baba: Kalindar Prasad Singh</h4>
              <p className="mps-muted">(01-07-1939 — 22-05-2017)</p>
              <p>
                He was a man full of spirit and had a great passion for educating people for the betterment of the world. He had donated all his sweat and blood
                toward the progress and building of the school.
              </p>
              <h3 style={{ marginTop: 20 }}>About the school</h3>
              <p>
                Modern Public School has been established to provide better cultural and educational facilities through English medium to children from several
                backgrounds. The institute provides hostel and transport facilities too. It earned a very good reputation and currently it is among the most
                sought-after in its area. The school has attained a strength of 500 within a short span of time. At MPS Jhabra, every student is provided
                opportunities to face challenges and overcome them with ease. Through regular class assemblies, children gain exposure and experience and improve
                their mettle. The school aims to develop intellectual students with great discipline, intense determination and passion to excel — the essential
                prerequisites to meet the challenges of contemporary society. Our motto of &apos;Service before self&apos; encompasses our core values. The school
                has classes from Nursery to VIII.
              </p>
            </div>
            <h3 className="mps-school-h3">Modern family</h3>
            <div className="mps-school-staff-row">
              <figure>
                <img src={siteImg('ekhlak.jpg')} alt="Ekhlak Ahmad" loading="lazy" />
                <figcaption>Co-ordinator — Ekhlak Ahmad</figcaption>
              </figure>
              <figure>
                <img src={siteImg('anil.jpg')} alt="Anil Singh" loading="lazy" />
                <figcaption>Anil Singh</figcaption>
              </figure>
            </div>
            <div className="mps-school-card" style={{ marginTop: 16 }}>
              <h3>Be part of our community</h3>
              <p>
                Modern Educational Society is a private body consistently working towards premier educational institutions, to promote, establish, run, develop and
                manage institutions beneficial to the community without any discrimination of caste, colour and creed.
              </p>
              <h3 style={{ marginTop: 16 }}>Mission &amp; vision</h3>
              <p>
                The school will be the well spring of collaborative learning adopting information technology tools through individual and collective activity. The
                endeavour is to inculcate values so that the rich heritage of our culture is secure in the hands of the new generation and promote harmony and
                spirit of unity. The ideology is to strive for wellness in society through its students by the practice of yoga and healthy dietary habits, in full
                transparency and involvement of all stakeholders in keeping with our motto &apos;service before self&apos;.
              </p>
            </div>
          </div>
        ) : null}

        {section === 'admissions' ? (
          <div className="mps-school-section">
            <h2 className="mps-school-h2">Admissions</h2>
            <div className="mps-school-two-col">
              <div className="mps-school-card">
                <h3>Fees rules</h3>
                <ul className="mps-school-list">
                  <li>Fees for the total calendar year can be deposited once in the month of July.</li>
                  <li>All fees should be paid before the 10th of every month. A fine of Rs 50/- will be charged after the 10th for that month only.</li>
                  <li>A student whose fees are not paid for consecutive months will not be allowed to enter the class until all dues are paid.</li>
                  <li>No exemption or reduction in fees will be made on account of holidays or absence for any cause.</li>
                  <li>No student will be allowed to appear for examination unless all dues are paid.</li>
                  <li>Bimonthly fees shall be charged from the month of November onward.</li>
                  <li>In addition to the monthly fee, other fees such as session fee, tour fee, function fee, exam fee, lab fee, computer fee etc. may be charged from time to time.</li>
                </ul>
                <p>
                  <strong>Note:</strong> The interpretation of any rules in this prospectus as well as any amendment to it rests solely with the governing body of
                  the school.
                </p>
                <h3 style={{ marginTop: 16 }}>School uniform</h3>
                <ul className="mps-school-list">
                  <li>General school uniform on Tuesday, Thursday and Friday.</li>
                  <li>P.T. (white) uniform on Monday, Wednesday and Saturday.</li>
                </ul>
              </div>
              <div className="mps-school-card">
                <h3>General rules</h3>
                <ul className="mps-school-list">
                  <li>Formal admission is complete only after the application form is considered by the Principal after an entrance test and interview of the child.</li>
                  <li>Three years is the age for admission in nursery. A corresponding age is fixed for subsequent classes.</li>
                  <li>The school authorities reserve the right to refuse admission without assigning any reason.</li>
                  <li>Every application for a leaving certificate shall be made in writing by the parents or guardian.</li>
                  <li>If the pupil is absent for ten consecutive days without prior application, his/her name will be struck off the rolls.</li>
                  <li>Students are not allowed to leave the premises during class hours without the knowledge of the Principal.</li>
                  <li>No visitors (parents or others) are allowed to see pupils or meet teachers during school hours.</li>
                  <li>Parents can meet the class teacher of their ward every Saturday between 10:00 and 12:00.</li>
                  <li>Promotion will depend on whole-year performance. Quarterly examination in September, half-yearly in December, annual in March, besides monthly tests.</li>
                </ul>
              </div>
            </div>
          </div>
        ) : null}

        {section === 'training' ? (
          <div className="mps-school-section">
            <h2 className="mps-school-h2">Training courses &amp; services</h2>
            <p>
              Education surpasses the four walls of a classroom. The core aim of education is to foster all-round development of a child — intellectual, physical,
              moral, sensible and social. Modern Public School has woven co-curricular activities into the curriculum.
            </p>
            <h3>Activities conducted regularly</h3>
            <ul className="mps-school-list mps-school-list-columns">
              {TRAINING_ACTIVITIES.map((t) => (
                <li key={t}>{t}</li>
              ))}
            </ul>
            <h3 style={{ marginTop: 24 }}>Annual exam papers (2019–20)</h3>
            <ul className="mps-school-links">
              {TRAINING_DRIVE_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} target="_blank" rel="noopener noreferrer">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ) : null}

        {section === 'success' ? (
          <div className="mps-school-section">
            <h2 className="mps-school-h2">Success stories</h2>
            <div className="mps-school-success-grid">
              <article className="mps-school-card">
                <img className="mps-school-portrait" src={siteImg('nikki.jpg')} alt="" loading="lazy" />
                <h4>Himanshu Sharma</h4>
                <p className="mps-school-sub">B.Tech Civil IIT Mumbai, 3rd year — JEE Adv. rank 2210</p>
                <p>
                  I would like to thank all the family members of Modern Public School who played important roles in this journey and supported me throughout. A
                  special thanks to Manoj Sir for his support and precious time so that I could achieve my goals.
                </p>
              </article>
              <article className="mps-school-card">
                <img className="mps-school-portrait" src={siteImg('sweta1.jpg')} alt="" loading="lazy" />
                <h4>Sweta Singh</h4>
                <p className="mps-school-sub">NET JRF qualified — Bachelor and Masters in Geography from B.H.U.</p>
                <p>
                  I am totally impressed by the idea of learning in Modern Public School. I qualified JRF with 70.89% and this was possible only with the help of
                  the Modern family. Thank you!
                </p>
              </article>
            </div>
            <p className="mps-muted" style={{ marginTop: 12 }}>
              More alumni stories and C.H.S. qualifiers may be added on the school portal:{' '}
              <a href={SITE_URL} target="_blank" rel="noopener noreferrer">
                {SITE_DISPLAY}
              </a>
              .
            </p>
          </div>
        ) : null}

        {section === 'gallery' ? (
          <div className="mps-school-section">
            <h2 className="mps-school-h2">School gallery</h2>
            <p className="mps-muted">Photos from the school website archive.</p>
            <div className="mps-school-gallery">
              {GALLERY_IMAGES.map((name) => (
                <a key={name} className="mps-school-gallery-item" href={siteImg(name)} target="_blank" rel="noopener noreferrer">
                  <img src={siteImg(name)} alt="" loading="lazy" />
                </a>
              ))}
            </div>
          </div>
        ) : null}

        {section === 'contact' ? (
          <div className="mps-school-section">
            <h2 className="mps-school-h2">Contact us</h2>
            <p>
              <strong>
                This institute is located in Varanasi district of U.P. in a small village named Jhabra. In front of the school campus there is a Jal Nigam office
                and it lies beside the Varanasi–Bhadohi connecting road.
              </strong>
            </p>
            <h3>Jhabra Deipur, Varanasi</h3>
            <p className="mps-school-display-upper">Modern Public School</p>
            <p>Jhabra Deipur, Jalalpur Jansa, Varanasi</p>
            <p>Tel: + 0542-2638377</p>
            <p>
              Mob:{' '}
              <a href="tel:+919451093677">9451093677</a> / <a href="tel:+917839167980">7839167980</a>
            </p>
            <p>
              Email:{' '}
              <a href="mailto:mpsvns1995@gmail.com">mpsvns1995@gmail.com</a>
            </p>
            <p>
              LinkedIn:{' '}
              <a href="https://www.linkedin.com/company/modern-public-school" target="_blank" rel="noopener noreferrer">
                linkedin.com/company/modern-public-school
              </a>
            </p>
            <h3 style={{ marginTop: 20 }}>Map</h3>
            <div className="mps-school-map-wrap">
              <iframe
                title="MODERN PUBLIC SCHOOL on Google Maps"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3606.3275646294974!2d82.81335245020412!3d25.326786983756854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398fd14e4f1c837d%3A0x1f280da84a2d4ca7!2sModern+public+school!5e0!3m2!1sen!2sin!4v1562842143980!5m2!1sen!2sin"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </div>
        ) : null}
      </div>

      <footer className="mps-school-footer">
        <div className="mps-school-social">
          <a href="https://www.facebook.com/modernpublicschool.varanasi/" target="_blank" rel="noopener noreferrer">
            <img src={siteImg('icon-facebook.gif')} alt="Facebook" />
          </a>
          <a href="https://twitter.com/ModernJhabra" target="_blank" rel="noopener noreferrer">
            <img src={siteImg('icon-twitter.gif')} alt="Twitter" />
          </a>
          <a href="https://www.youtube.com/channel/UCnM-G-ubn8FxB3LukvY1Ifw" target="_blank" rel="noopener noreferrer">
            <img src={siteImg('icon-youtube.gif')} alt="YouTube" />
          </a>
        </div>
        <p className="mps-school-copy">
          Copyright ©{' '}
          <a href={SITE_URL} target="_blank" rel="noopener noreferrer">
            {SITE_DISPLAY}
          </a>{' '}
          — All rights reserved · Content from school website archive
        </p>
      </footer>
    </div>
  );
}
